// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1_Yj4","label":"Labeled_label__3WBTU","divider":"Labeled_divider__3FUcu"};